 <div class="dialog-container" >
 <div id="close-button" (click)="onCancel()" >
  <i data-feather="x" id="close-button"  ></i>
</div> 

<h2 mat-dialog-title>Delete Quantum Emulator</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions class="dialog-btn-wrapper">
  <button class="desp-button dialog-btn no-fill-btn"  (click)="onCancel()">Cancel</button>
  <button class="desp-button dialog-btn"  color="warn" (click)="onDelete()">Confirm</button>
</mat-dialog-actions>
</div>